import { Component, Input, OnInit, inject } from '@angular/core';
import { BaseWidgetComponent } from '../../../../../home/home-widgets/widgets/base-widget.component';
import { FilterService } from '../../../../../_shared/services/filter.service';
import { KpiWidgetComponent } from '../../../../../_shared/components/kpi-widget/kpi-widget.component';
import { AssetOverviewService } from '../../../services/asset-overview.service';
import { ErrorHandlerService } from '../../../../../_shared/services/error-handler.service';
import { TranslocoService } from '@jsverse/transloco';
import { AssetSummaryKpiRequest } from '../../../models/asset-overview-request.model';

const ROLLING_WINDOW_DAYS = 30;

@Component({
  selector: 'app-inspections-and-compliance-widget',
  standalone: true,
  imports: [KpiWidgetComponent],
  templateUrl: './inspections-and-compliance-widget.component.html',
  styleUrl: './inspections-and-compliance-widget.component.scss'
})
export class InspectionsAndComplianceWidgetComponent extends BaseWidgetComponent implements OnInit {
  @Input({ required: true }) assetId!: number;

  hasError: boolean = false;
  errorMessage: string = '';

  private assetOverviewService = inject(AssetOverviewService);
  private errorHandlerService = inject(ErrorHandlerService);
  private readonly transloco: TranslocoService = inject(TranslocoService);

  constructor() {
    const filterService: FilterService = inject(FilterService);
    super(filterService);

    this.title = this.transloco.translate('assetOverview.widgets.inspectionsAndCompliance');
    this.isLoading = true;
    this.value = 0;
  }

  ngOnInit(): void {
    void this.loadInspectionsComplianceAsync();
  }

  protected override async onFilterChangeAsync(): Promise<void> {
  }

  public override formatValue(value: number): string {
    return `${value.toLocaleString('default', { maximumFractionDigits: 2 })}%`;
  }

  private async loadInspectionsComplianceAsync(): Promise<void> {
    this.hasError = false;
    this.isLoading = true;
    this.errorMessage = '';

    try {
      this.cancelSubject.next();
      const response = await this.assetOverviewService.getAssetInspectionsCompliance(this.buildRequest(), this.cancelSubject);
      this.value = response?.data?.totalValue ?? 0;

      const percentageChange = response?.data?.percentageChange;
      if (percentageChange !== undefined && percentageChange !== null) {
        this.percentageDifference = percentageChange;
      }

      this.isLoading = false;
    } catch (error) {
      this.errorHandlerService.handleError(error, {
        callback: (message) => {
          this.errorMessage = message;
          this.hasError = true;
          this.isLoading = false;
        }
      });
    }
  }

  private buildRequest(): AssetSummaryKpiRequest {
    const timeTo = new Date();
    const timeFrom = new Date(timeTo.getTime() - ROLLING_WINDOW_DAYS * 24 * 60 * 60 * 1000);
    const previousTimeFrom = new Date(timeFrom.getTime() - ROLLING_WINDOW_DAYS * 24 * 60 * 60 * 1000);

    return {
      assetId: this.assetId,
      timeFrom,
      timeTo,
      previousTimeFrom,
      previousTimeTo: timeFrom
    };
  }
}
